import Vue from 'vue'
import Router from 'vue-router'
import Home from "@/components/Home";
import SignIn from "@/components/SignIn";

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'SignIn',
            component: SignIn
        },
        {
            path: '/nothing',
            name: 'Home',
            component: Home
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js